import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import CompanyCibilUI from './CompanyCibilUI'
import EmailUpdateModalSF from './EmailUpdateModalSF.js'
import AccountPropertyListSF from './util/AccountPropertyListSF'
import CompanyNameUpdateModalSF from './CompanyNameUpdateModalSF'
import AddressUpdateModalSF from './AddressUpdateModalSF'
import AccountDescUpdateModalSF from './AccountDescUpdateModalSF'
import AccountStatusUpdateModalSF from './AccountStatusUpdateModalSF.js'
import UpdateAssignedUserModalSF from '../loan/UpdateAssignedUserModalSF'
import UpdateWomanLedModalSF from '../loan/UpdateWomanLedModalSF'
import openAILite from '../../../assets/finapp/openai-lite.png'
import openAIDark from '../../../assets/finapp/openai-dark.png'
import GSTAddModalSF from '../../../components/superUser/account/GSTAddModalSF.js'
import SecurityDepositAddModalSF from './SecurityDepositAddModalSF.js'
import PANValidationModalSF from './PANValidationModalSF.js'
import PartnerAccountUpdateModalSF from './PartnerAccountUpdateModalSF.js'
import LenderUpdateModalSF from './LenderUpdateModalSF.js'
import NachUpdateModalSF from './util/NachUpdateModalSF.js'
import PhoneNumberUpdateModalSF from './PhoneNumberUpdateModalSF.js'
import UpdateAppOnboardingStatusModalSF from './UpdateAppOnboardingStatusModalSF.js'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './AccountDetail.css'

const AccountDetailUI = ({ context, account,
  onRefreshClick, copyToClipboardText, onCopyToClipboard, guarantorName, coBorrowerName,
  onApplyGSTSubmit, gstSubmitted, gstSuccessMsg, gstErrorList, accountList, accountKeyValueList,
  onPanValidationClick, panValidationMode, onPanValidationCancel,
  onAccountDescUpdateClick, accountDescUpdateMode, onAccountDescUpdateCancel,
  accountStatusUpdateMode, onAccountStatusUpdateClick, onAccountStatusUpdateCancel,
  onCompanyNameUpdateClick, companyNameUpdateMode, onCompanyNameUpdateCancel,
  onAddressUpdateClick, addressUpdateMode, onAddressUpdateCancel,
  onAssignedUserClick, assignedUserMode, onAssignedUserCancel,
  womanLedMode, onWomanLedClick, onWomanLedCancel, onAddGSTClick, onAddSecurityDepositClick, onAddGSTCancelClick,
  addMode, depositAddMode, updateGuarantorMode, onGuarantorUpdateClick, onGuarantorUpdateCancel,
  lenderUpdateMode, onLenderUpdateClick, onLenderUpdateCancelClick,
  nachUpdateMode, onNachUpdateClick, onNachUpdateCancelClick,
  phoneNumberUpdateMode, onPhoneNumberUpdateClick, onPhoneNumberUpdateCancel,
  emailUpdateMode, onEmailUpdateClick, onEmailUpdateCancel,
  appOnboardingStatusUpdateMode, onAppOnboardingStatusUpdateClick, onAppOnboardingStatusUpdateCancel
}) =>
  <div className='su_acc'>
    <div className='g_m_top_50 g_flex_v'>
      <MainUI context={context} account={account} onRefreshClick={onRefreshClick}
        copyToClipboardText={copyToClipboardText} onCopyToClipboard={onCopyToClipboard}
        onApplyGSTSubmit={onApplyGSTSubmit}
        onAccountDescUpdateClick={onAccountDescUpdateClick} onAccountStatusUpdateClick={onAccountStatusUpdateClick}
        onPanValidationClick={onPanValidationClick} panValidationMode={panValidationMode} onPanValidationCancel={onPanValidationCancel}
        gstSubmitted={gstSubmitted} gstSuccessMsg={gstSuccessMsg} gstErrorList={gstErrorList}
        onAssignedUserClick={onAssignedUserClick} assignedUserMode={assignedUserMode} onAssignedUserCancel={onAssignedUserCancel}
        onWomanLedClick={onWomanLedClick} womanLedMode={womanLedMode} onWomanLedCancel={onWomanLedCancel}
        onNachUpdateClick={onNachUpdateClick} nachUpdateMode={nachUpdateMode} onNachUpdateCancelClick={onNachUpdateCancelClick}
          onPhoneNumberUpdateClick={onPhoneNumberUpdateClick} phoneNumberUpdateMode={phoneNumberUpdateMode} onPhoneNumberUpdateCancel={onPhoneNumberUpdateCancel}
          onEmailUpdateClick={onEmailUpdateClick} emailUpdateMode={emailUpdateMode} onEmailUpdateCancel={onEmailUpdateCancel}
        onAppOnboardingStatusUpdateClick={onAppOnboardingStatusUpdateClick} appOnboardingStatusUpdateMode={appOnboardingStatusUpdateMode} onAppOnboardingStatusUpdateCancel={onAppOnboardingStatusUpdateCancel}
      />

      <AccountDescUpdateModalSF context={context} account={account} updateMode={accountDescUpdateMode}
        onCancelClick={onAccountDescUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <AccountStatusUpdateModalSF context={context} account={account} updateMode={accountStatusUpdateMode}
        onCancelClick={onAccountStatusUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <CompanyNameUpdateModalSF context={context} account={account} updateMode={companyNameUpdateMode}
        onCancelClick={onCompanyNameUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <AddressUpdateModalSF context={context} account={account} updateMode={addressUpdateMode}
        onCancelClick={onAddressUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <Documents context={context} account={account}
        onApplyGSTSubmit={onApplyGSTSubmit}
        gstSubmitted={gstSubmitted}
        gstSuccessMsg={gstSuccessMsg}
        gstErrorList={gstErrorList} onCompanyNameUpdateClick={onCompanyNameUpdateClick}
        onAddressUpdateClick={onAddressUpdateClick}
        onAddGSTClick={onAddGSTClick}
        onAddSecurityDepositClick={onAddSecurityDepositClick}
        onLenderUpdateClick={onLenderUpdateClick}
      />
      <GSTAddModalSF
        context={context}
        account={account}
        onCancelCreate={onAddGSTCancelClick}
        onRefreshClick={onRefreshClick}
        addMode={addMode}
      />
      <SecurityDepositAddModalSF
        context={context}
        account={account}
        onCancelCreate={onAddGSTCancelClick}
        onRefreshClick={onRefreshClick}
        depositAddMode={depositAddMode}
      />
      <LenderUpdateModalSF
        context={context}
        account={account}
        onCancelCreate={onLenderUpdateCancelClick}
        onRefreshClick={onRefreshClick}
        lenderUpdateMode={lenderUpdateMode}
      />
      <PANValidationModalSF context={context} onCancelClick={onPanValidationCancel}
        updateMode={panValidationMode} onRefreshClick={onRefreshClick} account={account}
      />

      <PhoneNumberUpdateModalSF context={context} account={account} updateMode={phoneNumberUpdateMode}
        onCancelClick={onPhoneNumberUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <AccountPropertyListSF context={context} account={account}
        category='loan_props' categoryLabel='Loan-related parameters' />

      <AccountPropertyListSF context={context} account={account}
        category='dpd_report' categoryLabel='DPD report parameters' />

      <PartnerAccountUpdateModalSF context={context} account={account} updateMode={updateGuarantorMode} onGuarantorUpdateClick={onGuarantorUpdateClick}
        onCancelClick={onGuarantorUpdateCancel} onRefreshClick={onRefreshClick} accountList={accountKeyValueList} />
    </div>
  </div>

const MainUI = ({ context, account, onRefreshClick,
  copyToClipboardText, onCopyToClipboard, onAccountDescUpdateClick,
  onAccountStatusUpdateClick, onPanValidationClick,
  onAssignedUserClick, assignedUserMode, onAssignedUserCancel,
  womanLedMode, onWomanLedClick, onWomanLedCancel,
  onNachUpdateClick, nachUpdateMode, onNachUpdateCancelClick,
  onPhoneNumberUpdateClick, phoneNumberUpdateMode, onPhoneNumberUpdateCancel,
  onEmailUpdateClick, emailUpdateMode, onEmailUpdateCancel,
  onAppOnboardingStatusUpdateClick, appOnboardingStatusUpdateMode, onAppOnboardingStatusUpdateCancel
}) =>
  <CardUI title={
    <div className='g_flex_h g_flex_top'>
      <span className='g_flex_left'>
        {account.accountName}{account.businessName ? (' | ' + account.businessName) : ''}
      </span>
      <span className='g_flex_right g_flex_h g_flex_top'>
      </span>
    </div>
  }>
    {
      account.accountDesc &&
      <div className='g_flex_h g_flex_top g_m_bottom_100'>
        <span>{account.accountDesc}</span>
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onAccountDescUpdateClick}></span>
      </div>
    }

    {
      account.accountAIDesc &&
      <div className='g_flex_h g_flex_top g_m_bottom_100'>
        <img src={context.theme === 'lite' ? openAILite : openAIDark} alt="" width='20px' />
        <span className='g_m_left_50'>{account.accountAIDesc}</span>
        {
          !account.accountDesc &&
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onAccountDescUpdateClick}></span>
        }
      </div>
    }
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_v g_flex_left'>
        <span>Account number: {account.accountNumber}</span>
        <span className='g_flex_h g_flex_left'>
          Phone number: {account.phoneNumber}
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onPhoneNumberUpdateClick}></span>
        </span>
        <span>Zybra company id: {account.zybraCompanyId}</span>
        <span className='g_flex_h g_flex_left'>
          {account.accountId}
          <CopyToClipboard text={account.accountId}
            onCopy={onCopyToClipboard}>
            <span className='g_m_left_50 icon icon-clone g_cursor_pointer' />
          </CopyToClipboard>
          {
            copyToClipboardText === account.accountId &&
            <span className='g_m_left_50'>copied</span>
          }
        </span>
      </div>

      <div className='g_flex_v'>
        <div>
          PAN: {account.panNumber}
        </div>
        <span>Onboarded: {account.dateCreatedF1}</span>
        <span className='g_flex_h g_flex_left'>
          Email: {account.email}
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onEmailUpdateClick}></span>
        </span>
      </div>
    </div>

    <div className='g_flex_h g_m_top_50'>
      <span className='g_flex_h g_flex_left'>
        <BadgeUI label={account.assignedUserName ? account.assignedUserName : 'Underwriter'} />
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onAssignedUserClick} />
        <span className='g_m_left_50'>
          {account.womanLed && (
            <>
              <BadgeUI label='Woman led' />
              <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onWomanLedClick} />
            </>
          )}
          {!account.womanLed && (
            <Link to='#' data-row-id={account.accountId} onClick={onWomanLedClick}>
              Set woman led
            </Link>
          )}
        </span>
      </span>

      <span className='g_no_wrap_2'>
        {
          <span>
            {
              !account.nachTransfer &&
              <>Update Nach</>
            }
            <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onNachUpdateClick} />
          </span>
        }
        <span>
          <BadgeUI className='g_m_left_100' label={account.status} />
          <span className='icon icon-pencil g_link_2 g_m_left_50 g_m_right_50' onClick={onAccountStatusUpdateClick} />
        </span>
        {
          account.nachTransfer &&
          <span className='g_m_left_50'><BadgeUI label='nach' /></span>
        }
        {
          account.kycCompleted &&
          <BadgeUI className='g_m_left_50' label='kyc complete' />
        }
        {
          account.kycCompleted && account.status === 'frozen' &&
          <span className='g_m_left_50'><BadgeUI label='frozen' /></span>
        }
        <div className='g_flex_h g_flex_top g_m_top_50'>
          {!account.panNumber &&
            <Link to='#' onClick={onPanValidationClick}>
              Validate PAN
            </Link>
          }
        </div>
      </span>
    </div>

    <div className='g_flex_h g_m_top_50'>
      <div className='g_flex_h g_flex_left'>
        <BadgeUI label={account.appOnboardingStatus ? account.appOnboardingStatus : 'App onboarding status'} />
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onAppOnboardingStatusUpdateClick}></span>
      </div>
    </div>


    <UpdateAssignedUserModalSF context={context} account={account} updateMode={assignedUserMode}
      onCancelClick={onAssignedUserCancel} onRefreshClick={onRefreshClick}
    />
    <UpdateWomanLedModalSF context={context} account={account} updateMode={womanLedMode}
      onCancelClick={onWomanLedCancel} onRefreshClick={onRefreshClick}
    />
    <NachUpdateModalSF
      context={context}
      updateMode={nachUpdateMode}
      account={account}
      onCancelCreate={onNachUpdateCancelClick}
      onRefreshClick={onRefreshClick}
    />
    <PhoneNumberUpdateModalSF
      context={context}
      updateMode={phoneNumberUpdateMode}
      account={account}
      onCancelClick={onPhoneNumberUpdateCancel}
      onRefreshClick={onRefreshClick}
    />
    <EmailUpdateModalSF
      context={context}
      updateMode={emailUpdateMode}
      account={account}
      onCancelClick={onEmailUpdateCancel}
      onRefreshClick={onRefreshClick}
    />
    <UpdateAppOnboardingStatusModalSF
      context={context}
      updateMode={appOnboardingStatusUpdateMode}
      account={account}
      onCancelClick={onAppOnboardingStatusUpdateCancel}
      onRefreshClick={onRefreshClick}
    />
  </CardUI>

const Documents = ({ context, account, onApplyGSTSubmit, gstSubmitted, gstSuccessMsg, gstErrorList, onCompanyNameUpdateClick, onAddressUpdateClick,
  onAddGSTClick, onAddSecurityDepositClick, onLenderUpdateClick }) =>
  <div>
    <CardUI className='g_m_top_100' title='Corporate Identification Number'>
      CIN: {account.cinNumber}
      <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onCompanyNameUpdateClick}></span>
      <br />
      <span>
        {
          account.cinName &&
          <>
            Name in CIN: {account.cinName}<br />
          </>
        }
        {account.address ? account.address + ', ' : ''}
        {account.city ? account.city + ', ' : ''}
        {account.state ? account.state + ', ' : ''}
        {account.postalCode ? account.postalCode + ', ' : ''}
        {account.phoneNumber}
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onAddressUpdateClick}></span>
        <br />
        Incorporated: {account.incorporationDateF1}
      </span>
    </CardUI>

    <CardUI className='g_m_top_100' title='Goods and Services Tax Identification Number'>
      <span className='icon icon-plus' onClick={onAddGSTClick}

      />
      {
        // !account.gstList.length &&
        <FormSF context={context} buttonLabel='Apply GST from PAN'
          onSubmit={onApplyGSTSubmit} busy={gstSubmitted}
          successMsg={gstSuccessMsg} errorList={gstErrorList}
        />
      }
      <div className='g_flex_h g_flex_left wrap'>
        {
          account.gstList.map((gst, i) =>
            <div key={i} className='g_m_right_100 g_m_top_50'>
              GSTIN: {gst.gstin}<br />
              <span className='g_muted'>Registered: {gst.registrationDateF1}</span>
              <br />
              {gst.address ? gst.address + ', ' : ''}
              {gst.city ? gst.city + ', ' : ''}
              {gst.state ? gst.state + ' ' : ''}
              {gst.postalCode ? gst.postalCode + ', ' : ''}
              {gst.phoneNumber}
            </div>
          )
        }
      </div>
    </CardUI>
    <CardUI className='g_m_top_100' title='Security Deposit/Lender'>
      <div className='g_flex_h g_m_left_100 g_flex_top g_flex_right'>
        <span className='g_flex_v g_flex_left'>Security Deposit:</span>
        <span className=' g_flex_right'>{account.depositAmountF}</span>
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onAddSecurityDepositClick} />
      </div>
      <div className='g_flex_h g_m_left_100 g_flex_top g_flex_right'>
        <span className='g_flex_v g_flex_left'>Select Lender:</span>
        <span className=' g_flex_left'>{account.fundSource}</span>
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onLenderUpdateClick} />
      </div>
    </CardUI>

    <CompanyCibilUI context={context} account={account} />
  </div>

export default AccountDetailUI
